import React, { FunctionComponent } from 'react';
import { Salaries } from '../../../types/personShow';

type Props = {
  selectedSalary: number;
  salaries: Salaries[];
  onSelect: (id: number) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  selectedSalary,
  salaries,
  onSelect,
}) => {
  return (
    <div className="person__show__modal__inner salary">
      <p className="person__show__modal__inner--title">直近の年収を選択して保存してください</p>
      <ul className="person__show__modal__inner__list">
        {salaries.map((salary) => (
          <li
            key={`salaries_${salary.title}`}
            className={`salary ${selectedSalary === salary.id ? 'active' : ''}`}
            onClick={() => onSelect(salary.id)}
            data-id={salary.id}
          >
            {salary.title}
            {selectedSalary === salary.id && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
              >
                <path
                  d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z"
                  fill="#19190F"
                />
              </svg>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
